<div class="verification-container">
  <div class="card" [ngClass]="{'hidden':!isInitialPage}">
    <div class="icon-container">
      <mat-icon>email</mat-icon>
    </div>

    <h1> {{'verification_app.verify_your_email' | translate}} </h1>
    <p>
      <span> {{'verification_app.have_sent_verify_link' | translate}} {{'verification_app.to' | translate}}</span>
      <span class="email-display">{{email}}</span>
    </p>
    <p> {{'verification_app.check_your_inbox_click_link' | translate}} </p>

    <div class="status-box" *ngIf="state"
      [ngClass]="{'visible': state !== undefined,'info': state?.type === 'info', 'error': state?.type === 'error'}">
      {{ state!.message | translate}}
    </div>

    <div class="actions">
      <button class="resend-btn" type="button" color="primary" mat-raised-button (click)="resendVerificationEmail()"
        [disabled]="sending">
        {{ sendButtonText | translate }}
      </button>
      <button type="button" mat-stroked-button (click)="signInClick()">
        {{'verification_app.sign_in_diff_account' | translate}}
      </button>

      <button (click)="reloadUser()" class="btn-ghost">
        {{'verification_app.verified_my_email' | translate}}
      </button>
    </div>

    <footer>
      <p class="footer-text">
        {{'verification_app.not_found_email_check_spam' | translate}} {{'verification_app.or' | translate}}
        <a href="https://easyfo.com/contact.php" target="_blank">{{'verification_app.contact_support' | translate}}</a>.
      </p>
    </footer>
  </div>
</div>